// Lyrics for a track live in one string field, tracks/{id}.lyrics.
//   • Synced lyrics use the standard LRC format, one line per row:  [01:23.45] the words sung at that moment
//     (a line may carry several stamps: [00:10.00][01:02.00] chorus line). [offset:+250] shifts everything by ms.
//   • Plain lyrics are just text. They scroll freely and nothing is highlighted.
// The same format is read on web, iOS and Android, so lyrics typed anywhere show up everywhere.

const STAMP = /\[(\d{1,3}):(\d{1,2})(?:[.:](\d{1,3}))?\]/g;
const META = /^\[(ti|ar|al|au|by|length|re|ve|offset|#)[^\]]*\]\s*$/i;

function stampSeconds(m, s, f) {
  const frac = f ? parseInt(f, 10) / Math.pow(10, f.length) : 0;
  return parseInt(m, 10) * 60 + parseInt(s, 10) + frac;
}

/** → { synced: boolean, lines: [{ t: seconds|null, text }] } */
export function parseLyrics(raw) {
  const text = String(raw || "").replace(/\r/g, "");
  if (!text.trim()) return { synced: false, lines: [] };
  let offset = 0;
  const om = text.match(/^\[offset:\s*([+-]?\d+)\s*\]/im);
  if (om) offset = parseInt(om[1], 10) / 1000;

  const timed = [];
  let hasStamp = false;
  for (const row of text.split("\n")) {
    const stamps = [...row.matchAll(STAMP)];
    if (!stamps.length) continue;
    hasStamp = true;
    const words = row.replace(STAMP, "").trim();
    for (const s of stamps) timed.push({ t: Math.max(0, stampSeconds(s[1], s[2], s[3]) + offset), text: words });
  }
  if (hasStamp) {
    timed.sort((a, b) => a.t - b.t);
    return { synced: true, lines: timed };
  }
  const plain = text.split("\n").filter((l) => !META.test(l.trim())).map((l) => ({ t: null, text: l.trim() }));
  while (plain.length && !plain[0].text) plain.shift();
  while (plain.length && !plain[plain.length - 1].text) plain.pop();
  return { synced: false, lines: plain };
}

/** Index of the line being sung at `time` (-1 before the first line). */
export function activeIndex(lines, time) {
  let lo = 0, hi = lines.length - 1, ans = -1;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    if (lines[mid].t <= time + 0.15) { ans = mid; lo = mid + 1; } else hi = mid - 1;
  }
  return ans;
}

export function stamp(seconds) {
  const s = Math.max(0, seconds || 0);
  const m = Math.floor(s / 60), r = s - m * 60;
  return `[${String(m).padStart(2, "0")}:${r.toFixed(2).padStart(5, "0")}]`;
}

/** Lines of plain text (no stamps) from whatever is in the box, for the sync tool. */
export function plainLines(raw) {
  return String(raw || "").replace(/\r/g, "").split("\n").map((l) => l.replace(STAMP, "").trim()).filter((l) => !META.test(l));
}

export const MAX_LYRICS = 20000;